// extracted by mini-css-extract-plugin
export default {"logo":"_fP_q","tooltip":"CPf95"};